import { getOidc } from '@/features/oidc/oidc'
import { getFeatureFlag } from '@/lib/get-feature-flag'
import { useLingui } from '@lingui/react/macro'
import { createFileRoute, notFound } from '@tanstack/react-router'
import { SelfExclusion } from '@/features/self-exclusion/self-exclusion'
import { TertiaryPageLayout } from '@/routes/-tertiary-page-layout'
import { AccessControlInfo } from '@/features/access-controls/access-control-info'

export const Route = createFileRoute('/_app/your-play/access-controls/all')({
  component: AccessControls,
  beforeLoad: async () => {
    const oidc = await getOidc()
    if (oidc.isUserLoggedIn) {
      const userId = oidc.getDecodedIdToken()['pam-aid']
      const { enabled } = await getFeatureFlag({
        flagKey: 'nova-release-access-controls',
        userId,
      })

      if (!enabled) {
        throw notFound()
      }
    }
  },
})

function AccessControls() {
  const { t } = useLingui()

  return (
    <TertiaryPageLayout
      headerText={t`Access Controls`}
      infoDrawerContent={<AccessControlInfo />}
    >
      <SelfExclusion />
    </TertiaryPageLayout>
  )
}
